import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Sparkles } from 'lucide-react';
import { Button } from '../ui/Button';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/1HY3DSYVqG3SwFku6ZfET4/c5c1e3c7-73c4-412d-b100-eab77e25f3ef.png';
const highlights = ['12 tomos profesionales', '3 bonos incluidos', 'Certificado digital'];
function LotusIcon({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.4} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true" data-id="element-141">
      <path d="M12 4c1.6 2.1 2.4 4.4 2.4 7 0 2-.8 3.6-2.4 4.8-1.6-1.2-2.4-2.8-2.4-4.8 0-2.6.8-4.9 2.4-7z" data-id="element-142" />
      <path d="M12 15.8c-1.9.2-3.5-.4-4.9-1.8-1-1-1.6-2.3-1.9-3.9 1.9-.2 3.5.4 4.9 1.8" data-id="element-143" />
      <path d="M12 15.8c1.9.2 3.5-.4 4.9-1.8 1-1 1.6-2.3 1.9-3.9-1.9-.2-3.5.4-4.9 1.8" data-id="element-144" />
      <path d="M12 15.8c-2.6.6-5 .2-7.2-1.2-.9-.6-1.7-1.3-2.3-2.2 2.3-1 4.6-1.1 6.9-.3" data-id="element-145" />
      <path d="M12 15.8c2.6.6 5 .2 7.2-1.2.9-.6 1.7-1.3 2.3-2.2-2.3-1-4.6-1.1-6.9-.3" data-id="element-146" />
    </svg>;
}
export function Hero() {
  return <section className="relative flex min-h-[100svh] items-center overflow-hidden py-5 sm:py-8 lg:py-12" data-id="element-147">
      <div className="container relative z-10 mx-auto px-4" data-id="element-148">
        <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-149">
          <motion.div initial={{
          y: 14
        }} animate={{
          y: 0
        }} transition={{
          duration: 0.5
        }} className="flex flex-col items-center" data-id="element-150">
            <div className="mb-3 flex items-center justify-center gap-2.5 sm:mb-4" data-id="element-151">
              <span className="h-px w-7 bg-gold/50 sm:w-12" data-id="element-152" />
              <LotusIcon className="h-4 w-4 flex-shrink-0 text-gold sm:h-5 sm:w-5" data-id="element-153" />
              <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-gold sm:text-xs sm:tracking-[0.26em]" data-id="element-154">
                Academia Holística Argentina
              </span>
              <span className="h-px w-7 bg-gold/50 sm:w-12" data-id="element-155" />
            </div>

            <div className="relative mx-auto border border-gold/45 bg-mystic-800/55 px-5 py-3.5 shadow-[0_0_28px_rgba(109,74,156,0.22)] sm:px-10 sm:py-5" data-id="element-156">
              <span className="absolute -left-px -top-px h-4 w-4 border-l-2 border-t-2 border-gold" data-id="element-157" />
              <span className="absolute -right-px -top-px h-4 w-4 border-r-2 border-t-2 border-gold" data-id="element-158" />
              <span className="absolute -bottom-px -left-px h-4 w-4 border-b-2 border-l-2 border-gold" data-id="element-159" />
              <span className="absolute -bottom-px -right-px h-4 w-4 border-b-2 border-r-2 border-gold" data-id="element-160" />

              <h1 className="font-serif text-2xl font-bold uppercase leading-tight tracking-wide text-white sm:text-3xl md:text-4xl lg:text-5xl" data-id="element-161">
                Formación en
                <span className="mt-1 block font-display text-gold drop-shadow-[0_2px_10px_rgba(202,162,74,0.35)] sm:mt-2" data-id="element-162">
                  Tarot Profesional
                </span>
              </h1>
            </div>

            <p className="mt-3 max-w-xl text-sm font-medium leading-snug text-white sm:mt-4 sm:text-lg lg:text-xl" data-id="element-163">
              Aprende los dos métodos del tarot:{' '}
              <span className="text-gold" data-id="element-164">Rider-Waite</span> y{' '}
              <span className="text-gold" data-id="element-165">Marsella</span>, desde cero hasta un
              nivel profesional.
            </p>

            <p className="mt-2 hidden max-w-2xl text-sm leading-relaxed text-white/65 sm:block" data-id="element-166">
              Interpretá las 78 cartas, realizá lecturas profesionales y
              desarrollá una práctica sólida a tu propio ritmo.
            </p>
          </motion.div>

          <motion.div initial={{
          scale: 0.96
        }} animate={{
          scale: 1
        }} transition={{
          duration: 0.55,
          delay: 0.06
        }} className="relative mt-3 flex w-full items-center justify-center sm:mt-5" data-id="element-167">
            <motion.div aria-hidden="true" className="absolute h-[220px] w-[220px] rounded-full bg-[radial-gradient(circle,_rgba(109,74,156,0.26),_rgba(202,162,74,0.12)_42%,_transparent_70%)] sm:h-[315px] sm:w-[315px] lg:h-[390px] lg:w-[390px]" animate={{
            opacity: [0.65, 1, 0.65],
            scale: [0.95, 1.04, 0.95]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-168" />

            <motion.div aria-hidden="true" className="absolute h-[205px] w-[205px] rounded-full border border-gold/25 sm:h-[290px] sm:w-[290px] lg:h-[365px] lg:w-[365px]" animate={{
            rotate: 360
          }} transition={{
            duration: 42,
            repeat: Infinity,
            ease: 'linear'
          }} data-id="element-169">
              <span className="absolute -top-1 left-1/2 h-2 w-2 -translate-x-1/2 rounded-full bg-gold shadow-[0_0_12px_rgba(202,162,74,0.9)]" data-id="element-170" />
              <span className="absolute -right-1 top-1/2 h-1.5 w-1.5 -translate-y-1/2 rounded-full bg-gold/80" data-id="element-171" />
              <span className="absolute -bottom-1 left-1/2 h-1.5 w-1.5 -translate-x-1/2 rounded-full bg-gold/70" data-id="element-172" />
            </motion.div>

            <motion.div aria-hidden="true" className="absolute right-[17%] top-3 text-gold sm:right-[22%]" animate={{
            opacity: [0.25, 1, 0.25],
            scale: [0.8, 1.12, 0.8]
          }} transition={{
            duration: 2.8,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-173">
              <Sparkles size={18} data-id="element-174" />
            </motion.div>

            <motion.img src={MOCKUP_URL} alt="MegaPack Tarot Profesional: caja, tomos, tablet, celular, cartas y elementos místicos" fetchPriority="high" decoding="async" className="relative w-full max-w-[245px] object-contain drop-shadow-2xl sm:max-w-[370px] lg:max-w-[460px]" animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} whileHover={{
            scale: 1.025
          }} data-id="element-175" />
          </motion.div>

          <motion.div initial={{
          y: 14
        }} animate={{
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.12
        }} className="mt-3 flex w-full flex-col items-center sm:mt-4" data-id="element-176">
            <div className="flex flex-wrap justify-center gap-1.5 sm:gap-2" data-id="element-177">
              {highlights.map(highlight => <span key={highlight} className="inline-flex items-center gap-1 rounded-full border border-gold/25 bg-mystic-800/70 px-2.5 py-1 text-[10px] font-medium text-white/80 sm:px-3 sm:text-xs" data-id="element-178">
                  <CheckCircle2 size={12} className="text-gold" data-id="element-179" />
                  {highlight}
                </span>)}
            </div>

            <Button href="#premium-offer" variant="violet" size="lg" className="mt-3 px-8 py-3 text-sm shadow-[0_0_30px_rgba(109,74,156,0.65)] sm:mt-4 sm:px-10 sm:py-3.5 sm:text-base" data-id="element-180">
              QUIERO LA FORMACIÓN
            </Button>

            <p className="mt-2 text-[10px] text-white/50 sm:text-xs" data-id="element-181">
              Acceso digital inmediato · pago único
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}